import { logEvent } from './logGaEvent'

export const logExdCreateAccountClick = () => {
  logEvent(
    'internal_link',
    {
      link_name: 'express_deal_create_account',
      page_name: 'listings',
      product_name: 'air',
    },
    false
  )
}
